import { createContext } from 'react';

export const CustomTableColumnsCountContext = createContext<number>(1);
